import { render, staticRenderFns } from "./Button.vue?vue&type=template&id=69eddfc6&"
import script from "./Button.vue?vue&type=script&lang=js&"
export * from "./Button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgch/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69eddfc6')) {
      api.createRecord('69eddfc6', component.options)
    } else {
      api.reload('69eddfc6', component.options)
    }
    module.hot.accept("./Button.vue?vue&type=template&id=69eddfc6&", function () {
      api.rerender('69eddfc6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwg/js/components/Button.vue"
export default component.exports